import React, { useCallback, useEffect, useRef, useState } from "react";
import { Avatar, Input } from "antd";
import {
  ArrowLeftOutlined,
  PaperClipOutlined,
  SendOutlined,
} from "@ant-design/icons";
import "./ChatterCss.css";
import { IFetchAllDetails } from "../../interfaces/IPatient";
import { CHATTER } from "../../utils/constants";

interface ChatDetailProps {
  chat: {
    name: string;
    department: string;
  };
  onBack?: () => void;
  currentUserId?: any;
  jwtToken?: any;
  visitId?: any;
  patientDetails: IFetchAllDetails | null;
  onNotificationCountChange?: any;
  onMessageReceived?: (messageData: any) => void;
  onMessageRead?: (readData: any) => void;
}

type UnreadPayload = {
  type: "unreadCount";
  contextId?: string;
  count: number;
};

type NewMessagePayload = {
  type: "newMessage";
  contextId?: string;
  fromUserId?: string;
  messageId?: string;
  preview?: string;
};

const ChatDetail: React.FC<ChatDetailProps> = ({
  chat,
  onBack,
  currentUserId,
  jwtToken,
  visitId,
  patientDetails,
  onMessageRead,
  onNotificationCountChange,
  onMessageReceived,
}) => {
  const iframeRef = React.useRef<HTMLIFrameElement | null>(null);
  const [isConnected, setIsConnected] = useState(false);

  const isConnectedRef = useRef(isConnected);
  useEffect(() => {
    isConnectedRef.current = isConnected;
  }, [isConnected]);

  React.useEffect(() => {
    function handleMessage(event: MessageEvent) {
      // Only handle relevant message types
      const { type, count } = event.data || {};
      if (event.data && event.data.origin === "chat-plugin") {

        switch (event.data.type) {
          case "chat:notification:count":
            const newCount = event.data.count || 0;
            onNotificationCountChange?.(newCount);
            break;
        }
      }
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [isConnected]);

  const requestNotificationCount = useCallback(() => {
    if (iframeRef.current?.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        {
          type: "chat:notification:request",
        },
        "*"
      );
    }
  }, []);

  const handleIframeLoad = useCallback(() => {
    setIsConnected(true);
    setTimeout(requestNotificationCount, 1000);
  }, [requestNotificationCount]);

  useEffect(() => {
    if (isConnected) {
      const interval = setInterval(requestNotificationCount, 30000);
      return () => clearInterval(interval);
    }
  }, [isConnected, requestNotificationCount]);

  const iframeSrc =
    `${CHATTER.CHATTER_API}?` +                         //https://prod-chatter-chat-plugin.gsevenpro.com
    `userId=${encodeURIComponent(currentUserId)}` +
    `&token=${encodeURIComponent(jwtToken)}` +
    `&contextExternalId=${encodeURIComponent(`Visit-${visitId}`)}` +
    `&contextType=${encodeURIComponent("visit")}` +
    `&title=${encodeURIComponent(
      `Visit #${patientDetails?.visitInfoResponse?.creditNumber} - ${patientDetails?.patientResponse?.fullName}`
    )}`;

  return (
    // <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
    //   <div
    //     style={{
    //       display: "flex",
    //       alignItems: "center",
    //       padding: "10px 20px",
    //       borderBottom: "1px solid #D9D9D9",
    //       gap: "8px",
    //     }}
    //   >
    //     <Avatar size="large" style={{ backgroundColor: "#008B8B" }}>
    //       {chat.name.charAt(0)}
    //     </Avatar>
    //     <div>
    //       <div
    //         style={{
    //           fontWeight: "600",
    //           fontSize: "16px",
    //           textTransform: "initial",
    //         }}
    //       >
    //         {chat.name}
    //       </div>
    //       <div
    //         style={{
    //           fontSize: "14px",
    //           color: "#575757",
    //           textTransform: "initial",
    //         }}
    //       >
    //         {chat.department}
    //       </div>
    //     </div>
    //   </div>

    //   <div style={{ flex: 1, padding: "20px", overflowY: "auto" }}>
    //     <div
    //       style={{
    //         marginBottom: "20px",
    //         display: "flex",
    //         justifyContent: "flex-start",
    //       }}
    //     >
    //       <div>
    //         <div
    //           style={{
    //             display: "flex",
    //             alignItems: "center",
    //             gap: "8px",
    //             marginBottom: "10px",
    //           }}
    //         >
    //           <Avatar size="small" style={{ backgroundColor: "#008B8B" }}>
    //             {"K"}
    //           </Avatar>
    //           <div
    //             style={{
    //               fontWeight: "600",
    //               fontSize: "16px",
    //               textTransform: "initial",
    //             }}
    //           >
    //             {"Kamal Shah"}
    //           </div>
    //         </div>
    //         <div
    //           style={{
    //             padding: "10px 15px",
    //             borderRadius: "10px",
    //             backgroundColor: "#fff",
    //             maxWidth: "80%",
    //             fontSize: "15px",
    //             textTransform: "initial",
    //             boxShadow: "0px 2px 5.87px 0px #00000040",
    //           }}
    //         >
    //           Hi Kamal, certainly. I'll pull that up for you.
    //         </div>
    //       </div>
    //     </div>
    //     <div
    //       style={{
    //         marginBottom: "10px",
    //         display: "flex",
    //         alignItems: "end",
    //         flexDirection: "column",
    //       }}
    //     >
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           gap: "8px",
    //           marginBottom: "8px",
    //         }}
    //       >
    //         <Avatar size="small" style={{ backgroundColor: "#008B8B" }}>
    //           {chat.name.charAt(0)}
    //         </Avatar>
    //         <div
    //           style={{
    //             fontWeight: "600",
    //             fontSize: "16px",
    //             textTransform: "initial",
    //           }}
    //         >
    //           {chat.name}
    //         </div>
    //       </div>
    //       <div
    //         style={{
    //           padding: "10px 15px",
    //           borderRadius: "10px",
    //           backgroundColor: "#008B8B",
    //           color: "#fff",
    //           maxWidth: "60%",
    //           fontSize: "15px",
    //           textTransform: "initial",
    //         }}
    //       >
    //         Thanks! The insurance company needs it for approval.
    //       </div>
    //     </div>
    //     <div>
    //       {" "}
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           gap: "8px",
    //           marginBottom: "8px",
    //         }}
    //       >
    //         <Avatar size="small" style={{ backgroundColor: "#008B8B" }}>
    //           {"K"}
    //         </Avatar>
    //         <div
    //           style={{
    //             fontWeight: "600",
    //             fontSize: "16px",
    //             textTransform: "initial",
    //           }}
    //         >
    //           {"Kamal Shah"}
    //         </div>
    //       </div>
    //       <div
    //         style={{
    //           marginBottom: "20px",
    //           display: "flex",
    //           justifyContent: "flex-start",
    //         }}
    //       >
    //         <div
    //           style={{
    //             padding: "10px 15px",
    //             borderRadius: "10px",
    //             backgroundColor: "#fff",
    //             maxWidth: "100%",
    //             fontSize: "15px",
    //             textTransform: "initial",
    //             boxShadow: "0px 2px 5.87px 0px #00000040",
    //           }}
    //         >
    //           No problem. Here it is:
    //           <div
    //             style={{
    //               padding: "10px",
    //               display: "flex",
    //               alignItems: "center",
    //               gap: "8px",
    //             }}
    //           >
    //             <div>
    //               <img
    //                 src="https://edgepro-dev-document.s3.ap-south-1.amazonaws.com/vscode-icons_file-type-pdf2+(6).png"
    //                 alt=""
    //                 height={35}
    //               />
    //             </div>
    //             <span style={{ textTransform: "initial" }}>
    //               preauth_document123.pdf
    //             </span>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //     <div
    //       style={{
    //         marginBottom: "10px",
    //         display: "flex",
    //         alignItems: "flex-end",
    //         flexDirection: "column",
    //       }}
    //     >
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           gap: "8px",
    //           marginBottom: "8px",
    //         }}
    //       >
    //         <Avatar size="small" style={{ backgroundColor: "#008B8B" }}>
    //           {chat.name.charAt(0)}
    //         </Avatar>
    //         <div
    //           style={{
    //             fontWeight: "600",
    //             fontSize: "16px",
    //             textTransform: "initial",
    //           }}
    //         >
    //           {chat.name}
    //         </div>
    //       </div>
    //       <div
    //         style={{
    //           padding: "10px 15px",
    //           borderRadius: "10px",
    //           backgroundColor: "#008B8B",
    //           color: "#fff",
    //           maxWidth: "60%",
    //           fontSize: "15px",
    //           textTransform: "initial",
    //         }}
    //       >
    //         Got it. Thanks for the quick response!
    //       </div>
    //     </div>
    //   </div>

    //   <div
    //     style={{
    //       display: "flex",
    //       alignItems: "center",
    //       padding: "25px 15px",
    //     }}
    //   >
    //     <Input
    //       placeholder="Type a message"
    //       style={{
    //         flex: 1,
    //         marginRight: "10px",
    //         borderRadius: "10px",
    //         padding: "12px",
    //       }}
    //     />
    //     <div style={{ display: "flex", gap: "10px" }}>
    //       <PaperClipOutlined
    //         style={{
    //           fontSize: "20px",
    //           color: "#008B8B",
    //           cursor: "pointer",
    //           borderRight: "0.4px solid  #D1D1D1",
    //           paddingRight: "8px",
    //         }}
    //       />
    //       <SendOutlined
    //         style={{ fontSize: "20px", color: "#008B8B", cursor: "pointer" }}
    //       />
    //     </div>
    //   </div>
    // </div>
    <>
      <div className="body-chat">
        <div className="header-chat">
          <div className="chat-container" style={{ overflow: "auto" }}>
            <iframe
              ref={iframeRef}
              className="chat-iframe"
              src={iframeSrc}
              // src={`https://dev-chatter-chat-plugin.gsevenpro.com?userId=${currentUserId}&token=${jwtToken}&contextExternalId=${visitId}&contextType=visit&title=Visit #${patientDetails?.visitInfoResponse?.creditNumber} - ${patientDetails?.patientResponse?.fullName}`} //Visit%20%23001%20-%20John%20Doe
              title="Patient Visit Chat"
              // onLoad={handleIframeLoad}
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatDetail;
